import { forwardRef, SVGProps } from 'react'

import { cn } from '@/lib/utils'

export const LoaderIcon = ({ size = 16 }: { size?: number }) => {
  return (
    <svg
      height={size}
      strokeLinejoin="round"
      style={{ color: 'currentcolor' }}
      viewBox="0 0 16 16"
      width={size}
    >
      <g clipPath="url(#clip0_2393_1490)">
        <path d="M8 0V4" stroke="currentColor" strokeWidth="1.5" />
        <path d="M8 16V12" opacity="0.5" stroke="currentColor" strokeWidth="1.5" />
        <path
          d="M3.29773 1.52783L5.64887 4.7639"
          opacity="0.9"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M12.7023 1.52783L10.3511 4.7639"
          opacity="0.1"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M12.7023 14.472L10.3511 11.236"
          opacity="0.4"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M3.29773 14.472L5.64887 11.236"
          opacity="0.6"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M15.6085 5.52783L11.8043 6.7639"
          opacity="0.2"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M0.391602 10.472L4.19583 9.23598"
          opacity="0.7"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M15.6085 10.4722L11.8043 9.2361"
          opacity="0.3"
          stroke="currentColor"
          strokeWidth="1.5"
        />
        <path
          d="M0.391602 5.52783L4.19583 6.7639"
          opacity="0.8"
          stroke="currentColor"
          strokeWidth="1.5"
        />
      </g>
      <defs>
        <clipPath id="clip0_2393_1490">
          <rect fill="white" height="16" width="16" />
        </clipPath>
      </defs>
    </svg>
  )
}

export const PencilEditIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 20.107C11.5 19.5547 11.9477 19.107 12.5 19.107H21.5C22.0523 19.107 22.5 19.5547 22.5 20.107C22.5 20.6593 22.0523 21.107 21.5 21.107H12.5C11.9477 21.107 11.5 20.6593 11.5 20.107Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M18.5 3.98566C18.2026 3.98566 17.9174 4.1038 17.7071 4.31408L5.40299 16.6182L4.87439 18.7326L6.98877 18.204L19.2929 5.89987C19.397 5.79575 19.4796 5.67213 19.536 5.53609C19.5923 5.40004 19.6213 5.25423 19.6213 5.10698C19.6213 4.95972 19.5923 4.81391 19.536 4.67787C19.4796 4.54182 19.397 4.41821 19.2929 4.31408C19.1888 4.20996 19.0652 4.12736 18.9291 4.07101C18.7931 4.01466 18.6473 3.98566 18.5 3.98566ZM16.2929 2.89987C16.8783 2.31451 17.6722 1.98566 18.5 1.98566C18.9099 1.98566 19.3158 2.06639 19.6945 2.22325C20.0732 2.38011 20.4173 2.61003 20.7071 2.89987C20.997 3.18971 21.2269 3.5338 21.3837 3.9125C21.5406 4.29119 21.6213 4.69708 21.6213 5.10698C21.6213 5.51688 21.5406 5.92276 21.3837 6.30145C21.2269 6.68015 20.997 7.02424 20.7071 7.31408L8.20713 19.8141C8.07897 19.9422 7.91839 20.0332 7.74256 20.0771L3.74256 21.0771C3.40178 21.1623 3.04129 21.0625 2.79291 20.8141C2.54453 20.5657 2.44468 20.2052 2.52988 19.8644L3.52988 15.8644C3.57384 15.6886 3.66476 15.528 3.79291 15.3999L16.2929 2.89987Z"
        fill="black"
      />
    </svg>
  )
})

export const OrderXLogoIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ className, ...props }, ref) => {
    return (
      <svg
        width="134"
        height="28"
        viewBox="0 0 134 28"
        fill="currentColor"
        className={cn(['fill-foreground', className])}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <g clipPath="url(#clip0_31603_38274)">
          <path
            d="M74.0153 15.392C73.1656 15.392 72.4768 16.0809 72.4768 16.9305V22.766C72.4768 22.851 72.5457 22.9198 72.6307 22.9198H85.9161C86.0008 22.9198 86.07 22.9887 86.07 23.0737V25.4417C86.07 25.5267 86.0008 25.5956 85.9161 25.5956H69.7765C69.6916 25.5956 69.6227 25.5267 69.6227 25.4417V2.55961C69.6227 2.47464 69.6916 2.40576 69.7765 2.40576H85.88C85.9654 2.40576 86.0338 2.47464 86.0338 2.55961V4.92767C86.0338 5.01263 85.9654 5.08151 85.88 5.08151H72.6307C72.5457 5.08151 72.4768 5.15039 72.4768 5.23536V11.1778C72.4768 12.0275 73.1656 12.7163 74.0153 12.7163H83.4184C83.5031 12.7163 83.5723 12.7852 83.5723 12.8701V15.2382C83.5723 15.3232 83.5031 15.392 83.4184 15.392H74.0153Z"
            fill="currentColor"
          />
          <path
            d="M54.1265 2.40576C56.4574 2.40576 58.4078 2.71496 59.9775 3.33336C61.5711 3.92797 62.8435 4.76042 63.7949 5.83072C64.7463 6.90102 65.436 8.12592 65.8641 9.50541C66.2923 10.8849 66.5063 12.3477 66.5063 13.8937C66.5063 15.4397 66.2804 16.9143 65.8284 18.3176C65.3765 19.7208 64.6511 20.9695 63.6522 22.0636C62.677 23.1577 61.4045 24.0258 59.8348 24.668C58.265 25.2863 56.3623 25.5956 54.1265 25.5956H46.5988V2.40576H54.1265ZM49.4529 22.9198H54.1265C56.0055 22.9198 57.5514 22.6582 58.7645 22.135C60.0013 21.6117 60.9764 20.922 61.69 20.0657C62.4035 19.1857 62.903 18.2105 63.1884 17.1402C63.4976 16.0699 63.6522 14.9877 63.6522 13.8937C63.6522 12.7996 63.4976 11.7293 63.1884 10.6827C62.903 9.63623 62.4035 8.69674 61.69 7.86429C60.9764 7.00805 60.0013 6.33019 58.7645 5.83072C57.5514 5.33124 56.0055 5.08151 54.1265 5.08151H49.4529V22.9198Z"
            fill="currentColor"
          />
          <path
            d="M26.0368 25.3945C25.8244 25.3945 25.6522 25.2223 25.6522 25.0099V2.58933C25.6522 2.37691 25.8244 2.20471 26.0368 2.20471H35.8914C37.5088 2.20471 38.8882 2.45445 40.0298 2.95392C41.1715 3.42961 42.0397 4.15504 42.6343 5.1302C43.2527 6.10536 43.5618 7.33026 43.5618 8.80489C43.5618 9.80384 43.3954 10.6601 43.0624 11.3736C42.7532 12.0872 42.3131 12.6936 41.7424 13.1932C41.3335 13.5338 40.8697 13.8197 40.351 14.0506C39.9215 14.2418 39.8908 14.9508 40.351 15.084C41.2548 15.3456 41.9564 15.8213 42.4559 16.5111C42.9554 17.2008 43.2051 18.2354 43.2051 19.6149V25.0099C43.2051 25.2223 43.0329 25.3945 42.8205 25.3945H40.7356C40.5231 25.3945 40.351 25.2223 40.351 25.0099V19.6149C40.351 18.6635 40.1845 17.9262 39.8514 17.403C39.5423 16.8559 39.0071 16.4754 38.2461 16.2613C37.5087 16.0235 36.486 15.9045 35.1778 15.9045H30.0448C29.1951 15.9045 28.5063 16.5933 28.5063 17.443V25.0099C28.5063 25.2223 28.3341 25.3945 28.1217 25.3945H26.0368ZM28.5063 11.6903C28.5063 12.54 29.1951 13.2288 30.0448 13.2288H35.8914C37.5088 13.2288 38.7098 12.8245 39.4948 12.0158C40.3034 11.1833 40.7078 10.113 40.7078 8.80489C40.7078 7.54432 40.3034 6.58104 39.4948 5.91508C38.7098 5.22534 37.5088 4.88046 35.8914 4.88046H28.8909C28.6785 4.88046 28.5063 5.05266 28.5063 5.26507V11.6903Z"
            fill="currentColor"
          />
          <path
            d="M89.9985 25.3945C89.7862 25.3945 89.6139 25.2223 89.6139 25.0099V2.58933C89.6139 2.37691 89.7862 2.20471 89.9985 2.20471H99.8531C101.47 2.20471 102.85 2.45445 103.992 2.95392C105.133 3.42961 106.002 4.15504 106.596 5.1302C107.214 6.10536 107.523 7.33026 107.523 8.80489C107.523 9.80384 107.357 10.6601 107.024 11.3736C106.715 12.0872 106.275 12.6936 105.704 13.1932C105.295 13.5338 104.832 13.8197 104.312 14.0506C103.883 14.2418 103.852 14.9508 104.312 15.084C105.216 15.3456 105.918 15.8213 106.418 16.5111C106.917 17.2008 107.167 18.2354 107.167 19.6149V25.0099C107.167 25.2223 106.995 25.3945 106.782 25.3945H104.697C104.485 25.3945 104.312 25.2223 104.312 25.0099V19.6149C104.312 18.6635 104.146 17.9262 103.813 17.403C103.504 16.8559 102.969 16.4754 102.208 16.2613C101.47 16.0235 100.448 15.9045 99.1393 15.9045H94.0062C93.157 15.9045 92.4677 16.5933 92.4677 17.443V25.0099C92.4677 25.2223 92.2954 25.3945 92.0831 25.3945H89.9985ZM92.4677 11.6903C92.4677 12.54 93.157 13.2288 94.0062 13.2288H99.8531C101.47 13.2288 102.672 12.8245 103.456 12.0158C104.265 11.1833 104.669 10.113 104.669 8.80489C104.669 7.54432 104.265 6.58104 103.456 5.91508C102.672 5.22534 101.47 4.88046 99.8531 4.88046H92.8524C92.64 4.88046 92.4677 5.05266 92.4677 5.26507V11.6903Z"
            fill="currentColor"
          />
          <path
            d="M11.4918 25.9517C9.37505 25.9517 7.44849 25.4641 5.71222 24.489C3.99975 23.49 2.63215 22.0986 1.60942 20.3148C0.586683 18.531 0.0753174 16.426 0.0753174 14C0.0753174 11.574 0.586683 9.46908 1.60942 7.68525C2.63215 5.87763 3.99975 4.48625 5.71222 3.51109C7.44849 2.53592 9.37505 2.04834 11.4918 2.04834C13.6087 2.04834 15.5233 2.53592 17.2358 3.51109C18.972 4.48625 20.3515 5.87763 21.3743 7.68525C22.397 9.46908 22.9084 11.574 22.9084 14C22.9084 16.426 22.397 18.531 21.3743 20.3148C20.3515 22.0986 18.972 23.49 17.2358 24.489C15.5233 25.4641 13.6087 25.9517 11.4918 25.9517ZM11.4918 23.276C13.1092 23.276 14.56 22.931 15.8444 22.2413C17.1287 21.5278 18.1515 20.4813 18.9126 19.1018C19.6737 17.7223 20.0542 16.0217 20.0542 14C20.0542 11.9783 19.6737 10.2897 18.9126 8.93393C18.1515 7.55443 17.1287 6.50792 15.8444 5.79439C14.56 5.08085 13.1092 4.72409 11.4918 4.72409C9.89828 4.72409 8.44743 5.08085 7.13929 5.79439C5.85493 6.50792 4.8322 7.55443 4.0711 8.93393C3.31 10.2897 2.92945 11.9783 2.92945 14C2.92945 16.0217 3.31 17.7223 4.0711 19.1018C4.8322 20.4813 5.85493 21.5278 7.13929 22.2413C8.44743 22.931 9.89828 23.276 11.4918 23.276Z"
            fill="currentColor"
          />
          {/* The trailing X mark: set --logo-mark-fill to color it apart from the letters. */}
          <path
            d="M133.437 4.28743C133.587 4.43794 133.586 4.68146 133.436 4.83135L127.145 11.0961C125.636 12.5994 125.636 15.0432 127.145 16.5465L133.812 23.1853C133.962 23.3352 133.962 23.5788 133.812 23.7292L132.184 25.3644C132.034 25.5148 131.791 25.5154 131.64 25.3655L124.975 18.7265C122.258 16.0207 122.258 11.6218 124.975 8.91594L131.265 2.65122C131.415 2.50132 131.658 2.50182 131.808 2.65232L133.437 4.28743ZM119.484 8.8922C122.201 11.5981 122.201 15.9969 119.484 18.7028L112.818 25.3417C112.668 25.4916 112.424 25.4912 112.274 25.3406L110.645 23.7055C110.495 23.555 110.496 23.3115 110.647 23.1616L117.313 16.5227C118.822 15.0194 118.822 12.5756 117.313 11.0723L111.022 4.80761C110.872 4.65772 110.872 4.4142 111.022 4.26369L112.65 2.62859C112.8 2.47808 113.043 2.47758 113.194 2.62748L119.484 8.8922Z"
            fill="var(--logo-mark-fill, currentColor)"
          />
        </g>
        <defs>
          <clipPath id="clip0_31603_38274">
            <rect width="134" height="24" fill="white" transform="translate(0 2)" />
          </clipPath>
        </defs>
      </svg>
    )
  }
)

export const OrderXLogoIconMobile = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  (props, ref) => {
    return (
      <svg
        width="39"
        height="45"
        viewBox="0 0 39 45"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M30.9995 12.3285C31.1534 12.4792 31.1526 12.7231 30.9987 12.8733L24.5443 19.1483C22.9958 20.6541 22.9958 23.1019 24.5443 24.6077L31.3839 31.2575C31.5386 31.4076 31.5386 31.6516 31.3847 31.8023L29.7138 33.4401C29.5599 33.5908 29.3105 33.5914 29.1558 33.4412L22.317 26.7913C19.5294 24.081 19.5294 19.675 22.317 16.9646L28.7707 10.6896C28.9254 10.5394 29.1748 10.5399 29.3287 10.6907L30.9995 12.3285ZM16.6834 16.9408C19.471 19.6511 19.471 24.0572 16.6834 26.7676L9.84377 33.4174C9.68986 33.5676 9.43968 33.5671 9.28577 33.4163L7.61493 31.7786C7.46103 31.6278 7.46182 31.3838 7.61651 31.2337L14.4561 24.5839C16.0046 23.0781 16.0046 20.6303 14.4561 19.1245L8.00167 12.8495C7.84776 12.6994 7.84697 12.4554 8.00088 12.3047L9.67171 10.6669C9.82561 10.5161 10.075 10.5156 10.2297 10.6658L16.6834 16.9408Z"
          fill="#010101"
        />
      </svg>
    )
  }
)

export const GoogleLogoIcon = ({ size = 24 }: { size?: number }) => {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 25 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.7449 4.64C15.0443 4.64 16.5953 5.61334 17.4796 6.42667L20.9354 3.12C18.813 1.18667 16.0511 0 12.7449 0C7.95581 0 3.81976 2.69334 1.80615 6.61334L5.76534 9.62667C6.75853 6.73334 9.50683 4.64 12.7449 4.64Z"
        fill="#F25022"
      />
      <path
        d="M24.5 12.2666C24.5 11.28 24.4183 10.56 24.2415 9.81329H12.7449V14.2666H19.4932C19.3571 15.3733 18.6224 17.04 16.9898 18.16L20.8537 21.0933C23.1666 19 24.5 15.92 24.5 12.2666Z"
        fill="#4285F4"
      />
      <path
        d="M5.77891 14.3733C5.52041 13.6267 5.37075 12.8267 5.37075 12C5.37075 11.1733 5.52041 10.3733 5.76531 9.62668L1.80612 6.61334C0.976191 8.24001 0.5 10.0667 0.5 12C0.5 13.9333 0.976191 15.76 1.80612 17.3867L5.77891 14.3733Z"
        fill="#FBBC05"
      />
      <path
        d="M12.745 24C16.0511 24 18.8266 22.9334 20.8538 21.0934L16.9899 18.16C15.9559 18.8667 14.5681 19.36 12.745 19.36C9.5069 19.36 6.7586 17.2667 5.77901 14.3734L1.81982 17.3867C3.83343 21.3067 7.95588 24 12.745 24Z"
        fill="#34A853"
      />
    </svg>
  )
}

export const ThumbsIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ className, ...props }, ref) => {
    return (
      <svg
        viewBox="0 0 16 16"
        fill="none"
        stroke="currentColor"
        className={cn(['stroke-foreground', className])}
        xmlns="http://www.w3.org/2000/svg"
        {...props}
        ref={ref}
      >
        <path
          d="M3.86667 2.10265C5.22222 1.27056 8.74667 0.105643 12 2.10265M2 5.91638C2.62222 4.87628 4.70667 2.79606 8.06667 2.79606C11.4267 2.79606 13.4222 4.87628 14 5.91638M3 12.7811C2.51111 11.4405 2 8.27396 3.86667 6.33243C5.73333 4.39089 7.86667 4.50374 8.8 4.59891C9.93333 4.71448 12.4267 5.69449 13.3333 8.69001C13.5642 9.45275 13.7333 10.9878 12.2667 11.6717C11.3333 12.1068 9.86667 11.4636 9.8 10.1462C9.8 9.52209 9.56 8.19076 8.06667 8.13528C6.57333 8.07981 6.15556 9.3603 6.13333 10.0075C6.06667 11.2325 6.76 13.946 10.0667 15M7.99995 9.93814C7.99998 11.3249 9.13328 13.8906 12.2666 13.4745M6.46668 14.8613C5.64446 14.1448 4.08001 12.0322 4.40001 9.31407C4.51108 8.32019 5.38657 6.33243 7.99995 6.33243C11.2667 6.33243 11.7333 9.45275 11.6667 9.93814"
          stroke="currentColor"
          strokeLinecap="round"
          strokeLinejoin="round"
        />
      </svg>
    )
  }
)

export const SidebarIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
  return (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M13.5 2.5H2.5C2.23478 2.5 1.98043 2.60536 1.79289 2.79289C1.60536 2.98043 1.5 3.23478 1.5 3.5V12.5C1.5 12.7652 1.60536 13.0196 1.79289 13.2071C1.98043 13.3946 2.23478 13.5 2.5 13.5H13.5C13.7652 13.5 14.0196 13.3946 14.2071 13.2071C14.3946 13.0196 14.5 12.7652 14.5 12.5V3.5C14.5 3.23478 14.3946 2.98043 14.2071 2.79289C14.0196 2.60536 13.7652 2.5 13.5 2.5ZM2.5 3.5H5V12.5H2.5V3.5ZM13.5 12.5H6V3.5H13.5V12.5Z"
        fill="black"
        fillOpacity="0.4"
      />
    </svg>
  )
})

export const SearchIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5 4.10699C7.63401 4.10699 4.5 7.241 4.5 11.107C4.5 14.973 7.63401 18.107 11.5 18.107C15.366 18.107 18.5 14.973 18.5 11.107C18.5 7.241 15.366 4.10699 11.5 4.10699ZM2.5 11.107C2.5 6.13643 6.52944 2.10699 11.5 2.10699C16.4706 2.10699 20.5 6.13643 20.5 11.107C20.5 16.0776 16.4706 20.107 11.5 20.107C6.52944 20.107 2.5 16.0776 2.5 11.107Z"
        fill="black"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M16.4928 16.0999C16.8834 15.7094 17.5165 15.7094 17.9071 16.0999L22.2071 20.3999C22.5976 20.7904 22.5976 21.4236 22.2071 21.8141C21.8165 22.2046 21.1834 22.2046 20.7928 21.8141L16.4928 17.5141C16.1023 17.1236 16.1023 16.4904 16.4928 16.0999Z"
        fill="black"
      />
    </svg>
  )
})

export const ListSettingIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M6.6665 4.66667C6.6665 4.29848 6.96498 4 7.33317 4H13.3332C13.7014 4 13.9998 4.29848 13.9998 4.66667C13.9998 5.03486 13.7014 5.33333 13.3332 5.33333H7.33317C6.96498 5.33333 6.6665 5.03486 6.6665 4.66667Z"
      fill="#0C0D0E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M2.6665 11.3333C2.6665 10.9651 2.96498 10.6667 3.33317 10.6667H9.33317C9.70136 10.6667 9.99984 10.9651 9.99984 11.3333C9.99984 11.7015 9.70136 12 9.33317 12H3.33317C2.96498 12 2.6665 11.7015 2.6665 11.3333Z"
      fill="#0C0D0E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M11.3332 9.99999C10.5968 9.99999 9.99984 10.5969 9.99984 11.3333C9.99984 12.0697 10.5968 12.6667 11.3332 12.6667C12.0696 12.6667 12.6665 12.0697 12.6665 11.3333C12.6665 10.5969 12.0696 9.99999 11.3332 9.99999ZM8.6665 11.3333C8.6665 9.86056 9.86041 8.66666 11.3332 8.66666C12.8059 8.66666 13.9998 9.86056 13.9998 11.3333C13.9998 12.8061 12.8059 14 11.3332 14C9.86041 14 8.6665 12.8061 8.6665 11.3333Z"
      fill="#0C0D0E"
    />
    <path
      fillRule="evenodd"
      clipRule="evenodd"
      d="M4.66667 3.33333C3.93029 3.33333 3.33333 3.93029 3.33333 4.66667C3.33333 5.40305 3.93029 6 4.66667 6C5.40305 6 6 5.40305 6 4.66667C6 3.93029 5.40305 3.33333 4.66667 3.33333ZM2 4.66667C2 3.19391 3.19391 2 4.66667 2C6.13943 2 7.33333 3.19391 7.33333 4.66667C7.33333 6.13943 6.13943 7.33333 4.66667 7.33333C3.19391 7.33333 2 6.13943 2 4.66667Z"
      fill="#0C0D0E"
    />
  </svg>
))

export const EmptyProfileIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg
    width="24"
    height="24"
    viewBox="0 0 24 24"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <g clipPath="url(#clip0_31900_902)">
      <path
        d="M12.207 2.25C17.7388 2.25 22.2498 6.67531 22.25 12.207C22.25 17.7389 17.7389 22.25 12.207 22.25C6.67531 22.2498 2.25 17.7388 2.25 12.207C2.25022 6.67545 6.67545 2.25022 12.207 2.25ZM12.207 12.8369C9.45541 12.8371 7.05303 14.5138 6.44531 16.7207C6.28405 17.3074 6.79085 17.8095 7.39941 17.8096H17.0156C17.6241 17.8094 18.1309 17.3073 17.9697 16.7207C17.362 14.5137 14.9588 12.8369 12.207 12.8369ZM12.208 5.29199C10.3318 5.29199 8.83008 6.79271 8.83008 8.66895C8.83018 10.5451 10.3318 12.0459 12.208 12.0459C14.084 12.0457 15.5849 10.5449 15.585 8.66895C15.585 6.79287 14.084 5.29224 12.208 5.29199Z"
        fill="#B8BBBF"
      />
    </g>
    <defs>
      <clipPath id="clip0_31900_902">
        <rect width="24" height="24" fill="white" />
      </clipPath>
    </defs>
  </svg>
))

export const SettingsIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="currentColor"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    ref={ref}
  >
    <path
      d="M4 7C4.55228 7 5 7.44772 5 8C5 8.55229 4.55228 9 4 9C3.44772 9 3 8.55229 3 8C3 7.44772 3.44772 7 4 7Z"
      fill="currentColor"
    />
    <path
      d="M8 7C8.55228 7 9 7.44772 9 8C9 8.55229 8.55228 9 8 9C7.44772 9 7 8.55229 7 8C7 7.44772 7.44772 7 8 7Z"
      fill="currentColor"
    />
    <path
      d="M13 8C13 7.44772 12.5523 7 12 7C11.4477 7 11 7.44772 11 8C11 8.55228 11.4477 9 12 9C12.5523 9 13 8.55228 13 8Z"
      fill="currentColor"
    />
  </svg>
))

export const OrderXSimpleLogoIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width="24"
      height="23"
      viewBox="0 0 24 23"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M23.4995 1.77497C23.6534 1.92572 23.6526 2.16965 23.4987 2.31979L17.0443 8.59483C15.4958 10.1006 15.4958 12.5484 17.0443 14.0542L23.8839 20.704C24.0386 20.8541 24.0386 21.0981 23.8847 21.2488L22.2138 22.8866C22.0599 23.0373 21.8105 23.0379 21.6558 22.8877L14.817 16.2379C12.0294 13.5276 12.0294 9.12146 14.817 6.4111L21.2707 0.13606C21.4254 -0.0140827 21.6748 -0.0135858 21.8287 0.137169L23.4995 1.77497ZM9.18338 6.38732C11.971 9.09765 11.971 13.5037 9.18338 16.2141L2.34377 22.8639C2.18986 23.0141 1.93968 23.0136 1.78577 22.8628L0.114935 21.2251C-0.0389681 21.0743 -0.0381773 20.8303 0.116515 20.6802L6.95612 14.0304C8.50462 12.5246 8.50462 10.0768 6.95612 8.57102L0.501668 2.29601C0.347765 2.14587 0.346975 1.90194 0.500878 1.75119L2.17171 0.113392C2.32561 -0.0373633 2.57502 -0.0378595 2.72971 0.112283L9.18338 6.38732Z"
        fill="#86CECE"
      />
    </svg>
  )
)

export const EXCHANGE = {
  hyperliquid: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M16 8C16 12.4183 12.4183 16 8 16C3.58172 16 0 12.4183 0 8C0 3.58172 3.58172 0 8 0C12.4183 0 16 3.58172 16 8Z"
        fill="#072723"
      />
      <path
        d="M13.9996 7.95505C14.0105 8.98408 13.8044 9.96735 13.3994 10.9068C12.821 12.2445 11.4345 13.3384 10.1684 12.174C9.13581 11.225 8.94424 9.29849 7.39719 9.01647C5.35023 8.7573 5.30098 11.2365 3.96371 11.5166C2.4732 11.833 1.9788 9.21464 2.00069 8.02555C2.02258 6.83645 2.32543 5.16523 3.62073 5.16523C5.11124 5.16523 5.21158 7.52246 7.10346 7.39479C8.97709 7.2614 9.00992 4.80888 10.2341 3.7589C11.2904 2.85183 12.5328 3.51688 13.1549 4.60879C13.7314 5.61877 13.985 6.80405 13.9977 7.95505H13.9996Z"
        fill="#97FCE4"
      />
    </svg>
  )),
  binance: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <g clipPath="url(#clip0_31862_37677)">
        <path d="M0 0.5H16V16.5H0V0.5Z" fill="#F0B90A" />
        <path
          d="M5.92873 7.66532L7.99984 5.63421L10.0727 7.66621L11.2772 6.48399L7.99984 3.27155L4.72339 6.48399L5.92873 7.66621V7.66532ZM5.07717 8.49999L3.87184 7.31777L2.6665 8.49999L3.87184 9.68221L5.07717 8.49999ZM5.92873 9.33466L7.99984 11.3658L10.0727 9.33377L11.2781 10.5151L7.99984 13.7293L4.72339 10.5178L4.72161 10.516L5.92873 9.33466ZM12.1278 9.68221L13.3332 8.49999L12.1278 7.31777L10.9225 8.49999L12.1278 9.68221Z"
          fill="#0C0D0E"
        />
        <path
          d="M9.22201 8.49999L7.99979 7.29999L7.09579 8.18621L6.99179 8.28843L6.77846 8.49821L6.7749 8.49999L6.77668 8.50177L7.99979 9.69999L9.2229 8.49999H9.22201Z"
          fill="#0C0D0E"
        />
      </g>
      <defs>
        <clipPath id="clip0_31862_37677">
          <rect y="0.5" width="16" height="16" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )),
  bybit: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <g clipPath="url(#clip0_31862_37685)">
        <path d="M0 0.5H16V16.5H0V0.5Z" fill="#0C0D0E" />
        <path d="M10.6665 9.38887V5.83331H11.3092V9.38887H10.6665Z" fill="#F7A600" />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M1.77783 10.2778H3.15561C3.74317 10.2778 4.16361 9.94269 4.16361 9.34624C4.17066 9.1944 4.13099 9.04405 4.04992 8.91546C3.96886 8.78688 3.85032 8.68624 3.71028 8.62713C3.83294 8.56584 3.9361 8.47157 4.00817 8.35491C4.08023 8.23825 4.11836 8.10381 4.11828 7.96669C4.11828 7.41913 3.74317 7.06891 3.1005 7.06891H1.77783V10.2778ZM2.4205 7.61113H3.04983C3.32272 7.61113 3.47472 7.7738 3.47472 7.99335C3.47472 8.2138 3.32272 8.36224 3.04983 8.36224H2.4205V7.61113ZM2.4205 8.92402H3.09161C3.38228 8.92402 3.52094 9.09913 3.52094 9.31513C3.52094 9.53024 3.38228 9.7098 3.09161 9.7098H2.4205V8.92402ZM6.1245 10.2778V8.95513L7.11383 7.06891H6.41605L5.80983 8.3578L5.19472 7.06891H4.49783L5.48717 8.95513V10.2778H6.1245ZM8.93605 10.2778H7.55828V7.06891H8.88005C9.52272 7.06891 9.89783 7.41913 9.89783 7.96669C9.89783 8.32224 9.65694 8.55069 9.49072 8.62713C9.68894 8.71691 9.94405 8.91869 9.94405 9.34624C9.94405 9.94269 9.52272 10.2778 8.93517 10.2778H8.93605ZM8.82939 7.61113H8.20094V8.36224H8.83028C9.10317 8.36224 9.25517 8.2138 9.25517 7.99335C9.25517 7.7738 9.10317 7.61113 8.83028 7.61113H8.82939ZM8.87116 8.92402H8.20094V9.7098H8.87116C9.16272 9.7098 9.30139 9.53024 9.30139 9.31424C9.30139 9.09913 9.16272 8.92313 8.87116 8.92313V8.92402ZM13.3334 10.2778V7.61113H14.2223V7.06891H11.8578V7.61113H12.7183V10.2778H13.3334Z"
          fill="#FFFFFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_31862_37685">
          <rect y="0.5" width="16" height="16" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )),
  databento: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="#1A56DB" />
      <text x="5" y="12.5" fontSize="9" fontWeight="700" fill="#FFFFFF" fontFamily="sans-serif">
        D
      </text>
    </svg>
  )),
  // Fallback only — ExchangeIcon shows the brandfetch logo (exchange-registry.ts) and drops to
  // this badge when that fails.
  cme: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="currentColor" fillOpacity="0.15" />
      <text
        x="4.5"
        y="12.5"
        fontSize="9"
        fontWeight="700"
        fill="currentColor"
        fontFamily="sans-serif"
      >
        C
      </text>
    </svg>
  )),
  // Fallback only — ExchangeIcon shows the brandfetch logo (exchange-registry.ts) and drops to
  // this badge when that fails.
  nasdaq: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="currentColor" fillOpacity="0.15" />
      <text
        x="4.5"
        y="12.5"
        fontSize="9"
        fontWeight="700"
        fill="currentColor"
        fontFamily="sans-serif"
      >
        N
      </text>
    </svg>
  )),
  // Fallback only — ExchangeIcon shows the brandfetch logo (exchange-registry.ts) and drops to
  // this badge when that fails.
  nyse: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="currentColor" fillOpacity="0.15" />
      <text
        x="4.5"
        y="12.5"
        fontSize="9"
        fontWeight="700"
        fill="currentColor"
        fontFamily="sans-serif"
      >
        N
      </text>
    </svg>
  )),
  ibkr: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <image
        href="https://cdn.brandfetch.io/idx-RB6m2L/w/400/h/400/theme/dark/icon.jpeg?c=1bxid64Mup7aczewSAYMX&t=1772356379100"
        width="16"
        height="16"
        preserveAspectRatio="xMidYMid slice"
      />
    </svg>
  )),
  deribit: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <g clipPath="url(#clip0_31862_37693)">
        <path d="M0 0.5H16V16.5H0V0.5Z" fill="#25AF9A" />
        <path
          d="M7.11122 4.05554H5.33344V5.83332H3.55566V7.6111H5.33344V9.38888H3.55566V11.1667H5.33344V12.9444H7.11122V11.1667H8.00011V12.9444H9.77789V11.1667H10.6668C11.374 11.1667 12.0523 10.8857 12.5524 10.3856C13.0525 9.88551 13.3334 9.20723 13.3334 8.49999C13.3334 7.79274 13.0525 7.11447 12.5524 6.61437C12.0523 6.11427 11.374 5.83332 10.6668 5.83332H9.77789V4.05554H8.00011V5.83332H7.11122V4.05554ZM7.11122 9.38888V7.6111H10.6668C10.9025 7.6111 11.1286 7.70475 11.2953 7.87145C11.462 8.03815 11.5557 8.26424 11.5557 8.49999C11.5557 8.73573 11.462 8.96183 11.2953 9.12853C11.1286 9.29523 10.9025 9.38888 10.6668 9.38888H7.11122Z"
          fill="#FFFFFF"
        />
      </g>
      <defs>
        <clipPath id="clip0_31862_37693">
          <rect y="0.5" width="16" height="16" rx="8" fill="white" />
        </clipPath>
      </defs>
    </svg>
  )),
  // Placeholder monogram (Upbit's brand navy) — swap for the official mark asset.
  upbit: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="#093687" />
      <text x="4.5" y="12.5" fontSize="9" fontWeight="700" fill="#FFFFFF" fontFamily="sans-serif">
        U
      </text>
    </svg>
  )),
  lighter: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    // Placeholder monogram — swap for the real Lighter brand mark when available.
    <svg ref={ref} viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="11" fill="currentColor" fillOpacity="0.12" />
      <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="1.2" />
      <text x="12" y="16.5" textAnchor="middle" fontSize="12" fontWeight="600" fill="currentColor">
        L
      </text>
    </svg>
  )),
  derive: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    // Placeholder monogram — swap for the real Derive brand mark when available.
    <svg ref={ref} viewBox="0 0 24 24" fill="none" {...props}>
      <circle cx="12" cy="12" r="11" fill="currentColor" fillOpacity="0.12" />
      <circle cx="12" cy="12" r="11" stroke="currentColor" strokeWidth="1.2" />
      <text x="12" y="16.5" textAnchor="middle" fontSize="12" fontWeight="600" fill="currentColor">
        D
      </text>
    </svg>
  )),
  toss: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    // Monogram in Toss's brand blue, same shape as the upbit entry. The registry
    // also sets brandfetchDomain, so the real mark is used wherever Brandfetch
    // resolves and this stays the offline/error fallback.
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="#0064FF" />
      <text
        x="8"
        y="12.5"
        textAnchor="middle"
        fontSize="9"
        fontWeight="700"
        fill="#FFFFFF"
        fontFamily="sans-serif"
      >
        T
      </text>
    </svg>
  )),
  papertrade: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    // Neutral monogram; Papertrade is a simulated venue with no brand mark of its
    // own, so this is also the fallback when Brandfetch resolves nothing.
    <svg
      width="16"
      height="17"
      viewBox="0 0 16 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <rect y="0.5" width="16" height="16" rx="8" fill="#6B7280" />
      <text
        x="8"
        y="12.5"
        textAnchor="middle"
        fontSize="9"
        fontWeight="700"
        fill="#FFFFFF"
        fontFamily="sans-serif"
      >
        P
      </text>
    </svg>
  )),
}

export const CustomIcon = {
  AccountLoader: forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>((props, ref) => (
    <svg
      width="14"
      height="14"
      viewBox="0 0 14 14"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99984 0.583496C7.322 0.583496 7.58317 0.844663 7.58317 1.16683V3.50016C7.58317 3.82233 7.322 4.0835 6.99984 4.0835C6.67767 4.0835 6.4165 3.82233 6.4165 3.50016V1.16683C6.4165 0.844663 6.67767 0.583496 6.99984 0.583496Z"
        fill="var(--color-chart-mint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.5542 2.44576C11.782 2.67356 11.782 3.04291 11.5542 3.27071L9.86251 4.96238C9.63471 5.19019 9.26536 5.19019 9.03755 4.96238C8.80975 4.73458 8.80975 4.36523 9.03755 4.13742L10.7292 2.44576C10.957 2.21795 11.3264 2.21795 11.5542 2.44576Z"
        fill="var(--color-chart-mint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.9165 6.99984C9.9165 6.67767 10.1777 6.4165 10.4998 6.4165H12.8332C13.1553 6.4165 13.4165 6.67767 13.4165 6.99984C13.4165 7.322 13.1553 7.58317 12.8332 7.58317H10.4998C10.1777 7.58317 9.9165 7.322 9.9165 6.99984Z"
        fill="var(--color-chart-mint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M9.03755 9.03755C9.26536 8.80975 9.63471 8.80975 9.86251 9.03755L11.5542 10.7292C11.782 10.957 11.782 11.3264 11.5542 11.5542C11.3264 11.782 10.957 11.782 10.7292 11.5542L9.03755 9.86251C8.80975 9.63471 8.80975 9.26536 9.03755 9.03755Z"
        fill="var(--color-chart-mint)"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M6.99984 9.9165C7.322 9.9165 7.58317 10.1777 7.58317 10.4998V12.8332C7.58317 13.1553 7.322 13.4165 6.99984 13.4165C6.67767 13.4165 6.4165 13.1553 6.4165 12.8332V10.4998C6.4165 10.1777 6.67767 9.9165 6.99984 9.9165Z"
        fill="#FFFFFF"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M4.96238 9.03755C5.19019 9.26536 5.19019 9.63471 4.96238 9.86251L3.27071 11.5542C3.04291 11.782 2.67356 11.782 2.44576 11.5542C2.21795 11.3264 2.21795 10.957 2.44576 10.7292L4.13742 9.03755C4.36523 8.80975 4.73458 8.80975 4.96238 9.03755Z"
        fill="#FFFFFF"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M0.583496 6.99984C0.583496 6.67767 0.844663 6.4165 1.16683 6.4165H3.50016C3.82233 6.4165 4.0835 6.67767 4.0835 6.99984C4.0835 7.322 3.82233 7.58317 3.50016 7.58317H1.16683C0.844663 7.58317 0.583496 7.322 0.583496 6.99984Z"
        fill="#FFFFFF"
        fillOpacity="0.4"
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M2.44576 2.44576C2.67356 2.21795 3.04291 2.21795 3.27071 2.44576L4.96238 4.13742C5.19019 4.36523 5.19019 4.73458 4.96238 4.96238C4.73458 5.19019 4.36523 5.19019 4.13742 4.96238L2.44576 3.27071C2.21795 3.04291 2.21795 2.67356 2.44576 2.44576Z"
        fill="#FFFFFF"
        fillOpacity="0.4"
      />
    </svg>
  )),
}

export const VoiceIcon = forwardRef<SVGSVGElement, SVGProps<SVGSVGElement>>(
  ({ className, ...props }, ref) => (
    <svg
      width="16"
      height="16"
      viewBox="0 0 16 16"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      {...props}
      ref={ref}
    >
      <rect x="5" y="1" width="6" height="9" rx="3" fill="currentColor" />
      <path
        d="M3 8C3 10.7614 5.23858 13 8 13C10.7614 13 13 10.7614 13 8"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="8"
        y1="13"
        x2="8"
        y2="15"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
      <line
        x1="5.5"
        y1="15"
        x2="10.5"
        y2="15"
        stroke="currentColor"
        strokeWidth="1.2"
        strokeLinecap="round"
      />
    </svg>
  )
)
VoiceIcon.displayName = 'VoiceIcon'

PencilEditIcon.displayName = 'PencilEditIcon'
ListSettingIcon.displayName = 'ListSettingIcon'
OrderXLogoIcon.displayName = 'OrderXLogoIcon'
OrderXLogoIconMobile.displayName = 'OrderXMLogoIconMobile'
ThumbsIcon.displayName = 'ThumbsIcon'
SidebarIcon.displayName = 'SidebarIcon'
SearchIcon.displayName = 'SearchIcon'
EmptyProfileIcon.displayName = 'EmptyProfileIcon'
SettingsIcon.displayName = 'SettingsIcon'
OrderXSimpleLogoIcon.displayName = 'OrderXSimpleLogoIcon'
EXCHANGE.hyperliquid.displayName = 'HyperliquidIcon'
EXCHANGE.binance.displayName = 'BinanceIcon'
EXCHANGE.bybit.displayName = 'BybitIcon'
EXCHANGE.databento.displayName = 'DatabentoIcon'
EXCHANGE.cme.displayName = 'CmeIcon'
EXCHANGE.nasdaq.displayName = 'NasdaqIcon'
EXCHANGE.nyse.displayName = 'NyseIcon'
EXCHANGE.ibkr.displayName = 'IbkrIcon'
EXCHANGE.deribit.displayName = 'DeribitIcon'
EXCHANGE.upbit.displayName = 'UpbitIcon'
EXCHANGE.lighter.displayName = 'LighterIcon'
EXCHANGE.derive.displayName = 'DeriveIcon'
EXCHANGE.toss.displayName = 'TossIcon'
EXCHANGE.papertrade.displayName = 'PapertradeIcon'
CustomIcon.AccountLoader.displayName = 'AccountLoaderIcon'
